/**
 * @summary - Component that Provides Standard Task Details List
 * @author Purushothaman T
 * @since 19-06-2024
 */
import { Box, Stack } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import { standardtask } from "../../utility/constants/masters";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import utils from "../../utility/utilities";
import CreateNewBtn from "../commoncomponents/CreateNewBtn";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from "../commoncomponents/CustomDialog";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import CloseButton from "../commoncomponents/CloseButton";
import PageTitle from "../commoncomponents/PageTitle";
import { SuccessChips, ErrorChips } from "../../assets/styled-components/chips";
import SectionTitle from "../commoncomponents/SectionTitle";
import { dialogContent } from "../../utility/message";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";


const StandardTaskList = () => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [contentDialog, setContentDialog] = useState("");
  const [taskData, setTaskData] = useState({});
  const [rowData, setRowData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0)
  const column = standardtask.gridColumnWorkgroups;
  const [gridApi, setGridApi] = useState({});
  const navigate = useNavigate();
  const serviceOptions = [
    { label: "FEMS", value: "FEMS", id: 1 },
    { label: "BEMS", value: "BEMS", id: 2 },
  ];
  const [service, setService] = useState(serviceOptions[0]);
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGM004");

  useEffect(() => {
    fetchData(service);
  }, [service,filterModel, sortModel, pageIndex, pageSize]);

  // useEffect(() => {
  //   fetchData();
  // }, [service,]);
  const fetchData = async (service) => {
    setRowData([]);
    setIsLoading(true);
    try {
      // Obtain the bearer token from local storage or your state management system
      const token = getAuthToken("id_token");
      const facilityId = getFacilityId();
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      let response;
      if (service.label === "FEMS") {
        response = await axios.get(
          `${FemsGraph}/api/GraphWorkGroupDetails/GetworkgroupdetailsTaskcodeById/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
            filterModel
          )}&sortOptions=${JSON.stringify(sortModel)}`,config);
          setRowCount(response.data.totalCount);
          setExportCount(response.data.totalCount);
      } else {
        response = await axios.get(
          `${BemsGraph}/api/GraphWorkGroupDetails/GetworkgroupdetailsTaskcodeById/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
            filterModel
          )}&sortOptions=${JSON.stringify(sortModel)}`,config);
          setRowCount(response.data.totalCount);
          setExportCount(response.data.totalCount);
      }

      setRowData(
        response.data.items.map((data) => {
          return {
            ...data,
            service: service.label,
            isactive: data.isactive ? "Active" : "Inactive",
            effectivefrom: utils.formatDate({
              dateString: data.effectivefrom,
              format: "dd/mm/yyyy",
              dbdate: true,
            }),
          };
        })
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchExportdata = async () => {
   
    try {
      // Obtain the bearer token from local storage or your state management system
      const token = getAuthToken("id_token");
      const facilityId = getFacilityId();
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      let response;
      if (service.label === "FEMS") {
        response = await axios.get(
          `${FemsGraph}/api/GraphWorkGroupDetails/GetExportTaskDetails/${facilityId}?filterOptions=${JSON.stringify(
            filterModel
          )}&sortOptions=${JSON.stringify(sortModel)}`,config);
          
         setExportData(response.data)
      } else {
        response = await axios.get(
          `${BemsGraph}/api/GraphWorkGroupDetails/GetExportTaskDetails/${facilityId}?filterOptions=${JSON.stringify(
            filterModel
          )}&sortOptions=${JSON.stringify(sortModel)}`,config);
       
         setExportData(response.data)
      }

      setExportData(
        response.data.map((data) => {
          return {
            ...data,
            service: service.label,
            isactive: data.isactive ? "Active" : "Inactive",
            effectivefrom: utils.formatDate({
              dateString: data.effectivefrom,
              format: "dd/mm/yyyy",
              dbdate: true,
            }),
          };
        })
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(service);
  }, [service,filterModel, sortModel, pageIndex, pageSize]);




  const colDefs = [
    {
      field: column.wgcode.field,
      headerName: column.wgcode.header,
      maxWidth:120
    },
    {
      field: column.wgdesc.field,
      headerName: column.wgdesc.header,
    },

    { field: column.taskcode.field, headerName: column.taskcode.header },
    { field: column.taskdesc.field, headerName: column.taskdesc.header },
    {
      field: column.workinstructions.field,
      headerName: column.workinstructions.header,
    },
    {
      field: column.status.field,
      headerName: column.status.header,
      cellRenderer: (params) => {
        if (params.value === "Active") {
          return <SuccessChips label={params.value} />;
        } else {
          return <ErrorChips label={params.value} />;
        }
      },
    },
    {
      field: column.effectivefrom.field,
      headerName: column.effectivefrom.header,
      comparator: utils.dateComparator.bind(utils),
      filter:false,
      sort:false
    },
  ];
  const handleEdit = (data) => {
    navigate("/standardtask/task", {
      state: {
        taskData: {
          ...data,
          service: {
            label: data.service,
            value: data.service,
            id: data.serviceid,
          },
          workgroup: {
            label: `${data.wgcode} - ${data.wgdesc}`,
            value: `${data.wgcode} - ${data.wgdesc}`,
            id: data.femworkgroupdetailsId || data.bemworkgroupdetailsId,
          },
        },
        isEditMode: true,
      },
    });
  };
  const handleView = (data) => {
    navigate("/standardtask/task", {
      state: {
        taskData: {
          ...data,
          service: {
            label: data.service,
            value: data.service,
            id: data.serviceid,
          },
          workgroup: {
            label: `${data.wgcode} - ${data.wgdesc}`,
            value: `${data.wgcode} - ${data.wgdesc}`,
            id: data.femworkgroupdetailsId || data.bemworkgroupdetailsId,
          },
        },
        isViewMode: true,
      },
    });
  };
  const handleCreateClick = () => {
    navigate("/standardtask/task");
  };

  const handleDelete = (taskData) => {
    setOpenDeleteDialog(true);
    setTaskData(taskData);
  };

  const handleConfirmDelete = async () => {
    try {
      let response;
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      if (taskData.service === "FEMS") {
        response = await axios.delete(
          `${FemsGraph}/api/femtaskdetails/${taskData.id}`,
          config
        );
      } else if (taskData.service === "BEMS") {
        response = await axios.delete(
          `${BemsGraph}/api/bemtaskdetails/${taskData.id}`,
          config
        );
      }
      if (response.status === 204) {
        toggleDeleteModal(false)();
        setOpenDialog(true);
        setContentDialog(dialogContent.deleted);
        fetchData(service);
      }
    } catch (error) {
      if (error.response.status === 400) {
        toggleDeleteModal(false)();
        setOpenDialog(true);
        setContentDialog(error.response.data.detail);
      }
      return error.response;
    }
    finally {
      //setDeleteDialogOpen(false);
      //setRowToDelete(null);
      fetchData(service);
    }
  };

  const toggleDeleteModal = (newOpen) => () => {
    setOpenDeleteDialog(newOpen);
  };

  const handleDialogClose = () => {
    setOpenDeleteDialog(false);
    setOpenDialog(false);
  };

  // const handleServiceChange = (newValue) => {
  //   setService(newValue);
  //   if (newValue.label !== service.label) {
  //     fetchData(newValue);
  //   }
  // };

  const handleServiceChange = (selectedService) => {
    setService(selectedService);
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([])
    setSortModel([]);
  };

  const handleRefresh = () => {
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([])
    setSortModel([])
  };
  return (
    <>
      <PageTitle title={"Standard Task Details"} />
      <DefaultCard>
        <Stack
          mb={1}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <SectionTitle title={"Standard Task Details List"} />

          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 150 }}
              label={"Service"}
              options={serviceOptions}
              value={service}
              onChange={handleServiceChange}
              placeholder={"Select Service"}
              highlight={true}
              disableClearable={true}
            />
            {access?.canCreate && <CreateNewBtn
              onClick={handleCreateClick}
              link={"/standardtask/create"}
            />}
            <RefreshExportButtons
             
               export={fetchExportdata}
              handleRefresh={handleRefresh}
              exportFunction={fetchExportdata}
              exportData={exportData}
              refData={gridApi}
              //handleRefresh={() => fetchData(service)}
              title={`Standard Task Details`}
            />
          </Stack>
        </Stack>
        <Box>
          <CustomAgGrid
            rows={rowData}
            columns={colDefs}
            ref={gridApi}
            setGridApi={setGridApi}
            handleEdit={access?.canEdit && handleEdit}
            handleView={access?.canView && handleView}
            handleDelete={access?.canDelete && handleDelete}
            isLoading={isLoading}
            pagination={false}
            setFilterModel={setFilterModel}
            setSortModel={setSortModel}
            totalCount={rowCount}
            pageIndex={pageIndex}
            pageSize={pageSize}
            setPageIndex={setPageIndex}
            setPageSize={setPageSize}
          />
        </Box>
        <CustomDialog
          open={openDeleteDialog}
          onConfirm={handleConfirmDelete}
          content={dialogContent.confirmDelete}
          cancelBtn={"No"}
          confirmBtn={"Yes"}
          onClose={handleDialogClose}
        />
        <CustomDialog
          open={openDialog}
          content={contentDialog}
          confirmBtn={"Ok"}
          onConfirm={handleDialogClose}
        />
      </DefaultCard>
      <CloseButton />
    </>
  );
};

export default StandardTaskList;
